export default __webpack_public_path__ + "static/media/offers.30e0199d.svg";